import React from "react";
import sass from "pages/References/BusinessProcessRegistry/register.module.sass";
import Badge from "components-new/Badge";
import { Search } from "components-new";
import { Button } from "components/shared";
import { BUTTON_VARIANTS } from "components/shared/Button/Button";
import HeadPage from "pages/StepPages/StepFour/HeadPage";
import { useLocation, useNavigate } from "react-router-dom";

interface IHeadTemplateProps {
	archive: boolean;
	select: boolean;
	search: string;
	changeSearch: (str: string) => void;
	createTemplate: () => void;
	disabled: boolean;
}

const HeadTemplates: React.FC<IHeadTemplateProps> = ({
	archive,
	disabled,
	select,
	createTemplate,
	changeSearch,
	search,
}) => {
	const location = useLocation();
	const navigate = useNavigate();
	return (
		<HeadPage
			title={
				<p className={sass.headTitle}>
					Шаблоны реестра бизнес-процессов {archive && <Badge color={"#7CADAA"}>Архив</Badge>}
				</p>
			}>
			<div className={sass.head}>
				<Search className={sass.search} searchValue={search} handleSearch={(e) => changeSearch(e.target.value)} />
				{!(archive || select) && (
					<Button onClick={() => navigate(location.pathname + "/archive")} variant={BUTTON_VARIANTS.OUTLINED}>
						Перейти в архив
					</Button>
				)}
				{!(archive || select) && (
					<>
						{/*<Button variant={BUTTON_VARIANTS.OUTLINED}*/}
						{/*        onClick={() => setModal({active: true, data: null, loadTemplate: true})}>Загрузить*/}
						{/*    шаблон</Button>*/}
						<Button disabled={disabled} onClick={createTemplate}>
							Создать шаблон
						</Button>
					</>
				)}
			</div>
		</HeadPage>
	);
};

export default HeadTemplates;
